import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NotificationService } from "../../services/notification.service";
import { Utils } from "../../utils";

@Component({
  selector: 'app-complete-inquilino-info',
  templateUrl: './complete-inquilino-info.component.html',
  styleUrls: ['./complete-inquilino-info.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: {showError: true}
    }
  ]
})
export class CompleteInquilinoInfoComponent {

  public formStep1: FormGroup;
  public formStep2: FormGroup;
  public formStep3: FormGroup;
  public formStep4: FormGroup;
  public outsideStep1: boolean = false;
  public loadingSubmit: boolean = false;
  public loading: boolean = false;

  constructor(
    private readonly dialogRef: MatDialogRef<CompleteInquilinoInfoComponent>,
    private readonly formBuild: FormBuilder,
    private readonly snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) private input: {
      service: NotificationService,
      property_id: number
    }
  ) {
    this.dialogRef.disableClose = true;

    //info inquilino
    this.formStep1 = this.formBuild.group({
      property_id: [this.input.property_id],
      is_moral: [false],
      with_representate: [false],
      no_instrumento_publico: [{value: '', disabled: true}],
      fecha_registro: [{value: '', disabled: true}],
      licenciado: [{value: '', disabled: true}],
      no_notaria_publica: [{value: '', disabled: true}],
      ciudad_registro: [{value: '', disabled: true}],
      folio_mercantil: [{value: '', disabled: true}]
    });

    //representante inquilino
    this.formStep2 = this.formBuild.group({
      is_moral: [{value: false, disabled: true}],
      full_name: [{value: '', disabled: true}],
      no_instrumento_publico: [{value: '', disabled: true}],
      fecha_registro: [{value: '', disabled: true}],
      licenciado: [{value: '', disabled: true}],
      no_notaria_publica: [{value: '', disabled: true}],
      ciudad_registro: [{value: '', disabled: true}]
    });

    //obligado solidario
    this.formStep3 = this.formBuild.group({
      full_name: [{ value: '', disabled: false }],
      is_moral: [{ value: false, disabled: false }],
      with_representate: [{ value: false, disabled: false }],
      no_instrumento_publico: [{ value: '', disabled: true }],
      fecha_registro: [{ value: '', disabled: true }],
      licenciado: [{ value: '', disabled: true }],
      no_notaria_publica: [{ value: '', disabled: true }],
      ciudad_registro: [{ value: '', disabled: true }],
      folio_mercantil: [{ value: '', disabled: true }],
      full_address: [{ value: '', disabled: false }],
      email: [{ value: '', disabled: false }, [Validators.email]],
      property_address: [{ value: '', disabled: false }],
    });

    //representante de obligado solidario
    this.formStep4 = this.formBuild.group({
      is_moral: [{value: false, disabled: true}],
      full_name: [{value: '', disabled: true}],
      no_instrumento_publico: [{value: '', disabled: true}],
      fecha_registro: [{value: '', disabled: true}],
      licenciado: [{value: '', disabled: true}],
      no_notaria_publica: [{value: '', disabled: true}],
      ciudad_registro: [{value: '', disabled: true}]
    });

    this.getInit();
  }

  public getInit(): void {
    this.loading = true;
    this.input.service.isCompleteInfoPropertyForTenant(this.input.property_id).subscribe((response) => {
      this.loading = false;
    }, err => {
      if (err.status == 400) {
        Utils.showMessage(this.snackBar, 'Exitoso', 'La información para esta propiedad ya fue agregada', 'success', 3500);
      }

      this.loading = false;
      this.close(true);
    });
  }

  public close(value: boolean): void {
    this.dialogRef.close(value);
  }

  public interseptedStep1(): void {
    this.outsideStep1 = true;
  }

  public moralInquilino(event: MatSlideToggleChange): void {
    if (event.checked) {
      this.formStep1.get('no_instrumento_publico')!.enable();
      this.formStep1.get('fecha_registro')!.enable();
      this.formStep1.get('licenciado')!.enable();
      this.formStep1.get('no_notaria_publica')!.enable();
      this.formStep1.get('ciudad_registro')!.enable();
      this.formStep1.get('folio_mercantil')!.enable();
    } else {
      this.formStep1.get('no_instrumento_publico')!.disable();
      this.formStep1.get('fecha_registro')!.disable();
      this.formStep1.get('licenciado')!.disable();
      this.formStep1.get('no_notaria_publica')!.disable();
      this.formStep1.get('ciudad_registro')!.disable();
      this.formStep1.get('folio_mercantil')!.disable();
    }
  }

  public withRepresentateInquilino(event: MatSlideToggleChange): void {
    if (event.checked) {
      this.formStep2.get('is_moral')!.enable();
      this.formStep2.get('full_name')!.enable();
    } else {
      this.formStep2.get('is_moral')!.disable();
      this.formStep2.get('full_name')!.disable();
    }
  }

  public moralRepreInquilino(event: MatSlideToggleChange): void {
    if (event.checked) {
      this.formStep2.get('no_instrumento_publico')!.enable();
      this.formStep2.get('fecha_registro')!.enable();
      this.formStep2.get('licenciado')!.enable();
      this.formStep2.get('no_notaria_publica')!.enable();
      this.formStep2.get('ciudad_registro')!.enable();
    } else {
      this.formStep2.get('no_instrumento_publico')!.disable();
      this.formStep2.get('fecha_registro')!.disable();
      this.formStep2.get('licenciado')!.disable();
      this.formStep2.get('no_notaria_publica')!.disable();
      this.formStep2.get('ciudad_registro')!.disable();
    }
  }

  public moralObligadoSolidario(event: MatSlideToggleChange): void {
    if (event.checked) {
      this.formStep3.get('no_instrumento_publico')!.enable();
      this.formStep3.get('fecha_registro')!.enable();
      this.formStep3.get('licenciado')!.enable();
      this.formStep3.get('no_notaria_publica')!.enable();
      this.formStep3.get('ciudad_registro')!.enable();
      this.formStep3.get('folio_mercantil')!.enable();
      this.formStep3.get('full_address')!.enable();
      this.formStep3.get('email')!.enable();
      this.formStep3.get('property_address')!.enable();
    } else {
      this.formStep3.get('no_instrumento_publico')!.disable();
      this.formStep3.get('fecha_registro')!.disable();
      this.formStep3.get('licenciado')!.disable();
      this.formStep3.get('no_notaria_publica')!.disable();
      this.formStep3.get('ciudad_registro')!.disable();
      this.formStep3.get('folio_mercantil')!.disable();
      this.formStep3.get('full_address')!.disable();
      this.formStep3.get('email')!.disable();
      this.formStep3.get('property_address')!.disable();
    }
  }

  public withRepresentateObligado(event: MatSlideToggleChange): void {
    if (event.checked) {
      this.formStep4.get('is_moral')!.enable();
      this.formStep4.get('full_name')!.enable();
    } else {
      this.formStep4.get('is_moral')!.disable();
      this.formStep4.get('full_name')!.disable();
    }
  }

  public moralRepreObligado(event: MatSlideToggleChange): void {
    if (event.checked) {
      this.formStep4.get('no_instrumento_publico')!.enable();
      this.formStep4.get('fecha_registro')!.enable();
      this.formStep4.get('licenciado')!.enable();
      this.formStep4.get('no_notaria_publica')!.enable();
      this.formStep4.get('ciudad_registro')!.enable();
    } else {
      this.formStep4.get('no_instrumento_publico')!.disable();
      this.formStep4.get('fecha_registro')!.disable();
      this.formStep4.get('licenciado')!.disable();
      this.formStep4.get('no_notaria_publica')!.disable();
      this.formStep4.get('ciudad_registro')!.disable();
    }
  }

  public submit(): void {
    const form = {
      renter: this.formStep1.value,
      repre_renter: this.formStep2.value,
      obligated_solidarity: this.formStep3.value,
      repre_obligated: this.formStep4.value,
      property_id: this.input.property_id
    };

    this.loadingSubmit = true;

    this.input.service.completeInfoPropertyTenant(form).subscribe(response => {
      Utils.showMessage(this.snackBar, 'Exitoso', 'La información fue enviada', 'success', 3500);

      this.loadingSubmit = false;
      this.close(true);
    }, err => {
      this.loadingSubmit = false;

      let errorMessage = 'Por favor intentelo mas tarde';
      if (err.error.details) {
        errorMessage = 'Por favor intentelo mas tarde';
      } else if (typeof err.error === 'object') {
        errorMessage = '';

        Object.keys(err.error).forEach(key => {
          if (Array.isArray(err.error[key])) {
            err.error[key].forEach((messages: any) => {
              errorMessage += `${messages}<br>`;
            });
          } else {
            errorMessage += `${err.error[key]}<br>`;
          }
        });
      }

      Utils.showMessage(this.snackBar, 'Error', errorMessage ?? 'Por favor intentelo mas tarde', 'error', 4000);
    });
  }
}